<template>
  <div>
    <topsearch
      :searchForm.sync="listParams"
      @submit="getList"
      @onClear="onClear"
      page="record"
    />
    <div class="table">
      <div class="tableBox">
        <div class="title">申请记录</div>
        <el-table
          row-class-name="defTableRowStyle"
          header-row-class-name="defTableHeaderStyle"
          :data="list"
          style="width: 100%"
        >
          <el-table-column label="合同名称" show-overflow-tooltip prop="contract.subject">
            <template slot-scope="scope">
              <span>{{ scope.row.contract.subject || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="合同编号" show-overflow-tooltip prop="contract.subject">
            <template slot-scope="scope">
              <span>{{ scope.row.contract.contractNo || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="insuranceVersion" label="合同保障" min-width="120">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.insuranceState || scope.row.insuranceSnapshot">
                  <div>
                    <hetongbaoIcon :value="scope.row.insuranceState" :item="scope.row" />
                  </div>
                  <el-tooltip effect="dark" placement="top">
                    <div
                      style="width: 300px"
                      slot="content"
                      v-if="scope.row.insuranceSnapshot"
                    >
                      {{ scope.row.insuranceSnapshot.detail }}
                    </div>
                    <p style="font-size: 12px; margin-top: -4px" class="pointer">
                      {{ scope.row.insuranceSnapshot.title || "--" }}
                    </p>
                  </el-tooltip>
                </div>
                <div v-else>--</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="出证类型" show-overflow-tooltip prop="certificateType">
            <template slot-scope="scope">
              <span v-html="certificateTypeRender(scope.row.certificateType)"></span>
            </template>
          </el-table-column>
          <el-table-column label="申请人" show-overflow-tooltip prop="account.name">
            <template slot-scope="scope">
              <span>{{ scope.row.emp.name || "--" }}</span>
            </template>
          </el-table-column>

          <el-table-column label="申请时间" show-overflow-tooltip prop="account.name">
            <template slot-scope="scope">
              <span>{{ scope.row.updatedAt | timeFormat("yyyy-mm-dd hh:MM") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="出证进度" show-overflow-tooltip prop="weixin">
            <template slot-scope="scope">
              <span v-html="certificateStateRender(scope.row.state)"></span>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <div style="font-size: 14px; color: #0062ff">
                <span @click="operate('chakan', row)" class="pointer">详情</span>
                <template v-if="row.certificateType === 0 && row.state === 2">
                  <span style="color: #eeeeee">｜</span>
                  <span @click="operate('xiazai', row)" class="pointer">下载</span>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <div class="pagination_left"></div>
          <el-pagination
            :current-page="parm.current"
            :page-sizes="[30, 40, 50, 60]"
            :page-size.sync="parm.size"
            popper-class="paginationTopStyle"
            background
            layout="total,  prev, pager, next, jumper"
            :total="parm.total"
            @size-change="sizeChange"
            @current-change="currentChange"
            :popper-options="{
              placement: 'top',
              boundariesPadding: 10,
            }"
          >
          </el-pagination>
        </div>
      </div>
      <pdfPopup ref="pdfPopupRef" />
      <issuePopup ref="issuePopupRef" @onDownload="operate('xiazai', $event)" />
    </div>
  </div>
</template>

<script>
const listParams = {
  keyword: "",
  certificateType: null, //出证类型
  state: null, //出证状态
  createdAtFrom: null, //申请出证时间开始
  createdAtTo: null, //申请出证时间结束
  empUuid: null,  //申请人UUID
  insuranceState: null, //合同锁状态
};
import topsearch from "./recordTopsearch.vue";
import getList from "@/mixins/getList";
import selectData from "@/mixins/selectData";
import pdfPopup from "@/components/pdfPopup";
import hetongbaoIcon from "@/components/hetongbaoIcon";
import issuePopup from "./issuePopup.vue";
export default {
  mixins: [selectData, getList],
  components: {
    topsearch,
    pdfPopup,
    hetongbaoIcon,
    issuePopup,
  },
  data() {
    return {
      list: [],
      listParams: {
        ...listParams,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    onClear() {
      this.listParams = { ...listParams };
    },
    listApi(parm) {
      let data = { ...parm, ...this.listParams };
      return this.$api.getCertificateRequestList(data);
    },
    operate(type, res) {
      if (type == "chakan") {
        // window.open(`${this.$oss}${res.certificateUrl}`);
        // this.$refs.pdfPopupRef.onShow({
        //   src: `${this.$oss}${res.certificateUrl}`,
        //   title: res.contract.subject,
        // });
        this.$refs.issuePopupRef.onShow(res);
      } else if (type == "xiazai") {
        this.$utils.downloadFile(this.$oss + res.certificateUrl, res.contract.subject);
        // window.open(`${this.$oss}${res.certificateUrl}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  background: #fff;

  margin-top: 16px;
  border-radius: 6px;
  .tableBox {
    padding: 0 16px;
    .title {
      height: 54px;
      display: flex;
      align-items: center;

      font-weight: 500;
      line-height: normal;
      font-size: 14px;
      color: #262626;
    }
  }
  .pagination {
    display: flex;
    height: 60px;
    align-items: center;
    justify-content: space-between;
    .all {
      font-size: 14px;
      color: #666666;
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        color: #0062ff;
      }
    }
  }
}
</style>
